<template>
    <div class="brick_inner">
        <ListTopBox :useHelpBox="true">
            <template v-slot:leftItems>
                <div class="l_t_item">
                    <select class="form-select w_auto" id="yearBox" @change="changeIndex($event.target.selectedIndex)">
                        <option :value="i" v-for="(data,i) in year">{{ data }} {{$t('common.selectBox.year')}}</option>
                    </select>
                </div>
            </template>
            <template v-slot:helpMessage>
                <h4></h4>
            </template>
        </ListTopBox>
        <div class="tbl_list_wrap">
            <div id="scroll_table" class="list_scroll_wrap" style="max-height:70vh;">
                <table class="list_tbl">
                    <colgroup>
                        <col style="width:75px;">
                        <col style="width:60px;">
                        <col style="width:160px;">
                        <col style="">
                        <col style="width:60px;">
                        <col style="width:80px;">
                        <col style="width:80px;">
                        <col style="width:60px;">
                        <col style="width:80px;">
                        <col style="width:90px;">
                        <col style="width:90px;">
                    </colgroup>
                    <thead class="fix_header">
                    <tr>
                        <th scope="col" class="">{{ $t('common.no') }}</th>
                        <th scope="col"><ListHeader @clickHeader="sorting(0);" :ClickCnt="request.clickCnt[0]" tagName="teaching.list.curriculum.zTerm"/></th>
                        <th scope="col"><ListHeader @clickHeader="sorting(1);" :ClickCnt="request.clickCnt[1]" tagName="teaching.list.curriculum.hakje"/></th>
                        <th scope="col"><ListHeader @clickHeader="sorting(2);" :ClickCnt="request.clickCnt[2]" tagName="teaching.list.curriculum.text1"/></th>
                        <th scope="col"><ListHeader @clickHeader="sorting(3);" :ClickCnt="request.clickCnt[3]" tagName="teaching.list.curriculum.hakju"/></th>
                        <th scope="col"><ListHeader @clickHeader="sorting(4);" :ClickCnt="request.clickCnt[4]" tagName="teaching.list.curriculum.time2"/></th>
                        <th scope="col"><ListHeader @clickHeader="sorting(5);" :ClickCnt="request.clickCnt[5]" tagName="teaching.list.curriculum.langu"/></th>
                        <th scope="col"><ListHeader @clickHeader="sorting(6);" :ClickCnt="request.clickCnt[6]" tagName="teaching.list.curriculum.teamT"/></th>
                        <th scope="col">{{ $t('teaching.list.curriculum.penal') }}</th>
                        <th scope="col">{{ $t('teaching.list.curriculum.avg') }}</th>
                        <th scope="col">{{ $t('teaching.list.curriculum.totAvg') }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-if="curriculums !== undefined && curriculums.length > 0"
                        v-for="(curriculum, idx) in curriculums" v-bind:key="idx"
                    >
                        <td>{{ idx + 1 + response.pageable.offset}}</td>
                        <td>{{ $t('common.cnt.zTerm', {count:curriculum.zterm}) }}</td>
                        <td>{{ curriculum.hakje }}</td>
                        <td class="text-start">{{ curriculum.text1 }}</td>
                        <td>{{ curriculum.hakju }}</td>
                        <td>{{ curriculum.time2 }}</td>
                        <td>{{ $localeCode(curriculum.languCd) }}</td>
                        <td>{{ curriculum.teamt }}</td>
                        <td>{{ $localeCode(curriculum.penalCd) }}</td>
                        <td>{{ curriculum.avr }}</td>
                        <td>{{ curriculum.totavr }}</td>
                    </tr>
                    <tr v-else>
                        <td colspan="11">{{ $t('common.noData') }}</td>
                    </tr>
                    <tr style="border-top: 1px solid #a5a5a5;"
                        v-if="curriculums !== undefined && curriculums.length > 0"
                    >
                        <td> {{ $t('common.points') }} </td>
                        <td colspan="10"> {{ curriculumScore }} </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <PaginationBox :response="response" pageCount="5" @movePage="pagingCurriculumList"/>
        </div>
    </div>
</template>

<script>
import ListTopBox from "@/components/common/ListTopBox.vue";
import {getCurriculumList, getCurriculumScore, getCurriculumYearList} from "@/api/teaching/teaching";
import {
    createSortListAndClickCnt,
    deepCopyObject,
    isNull,
    setSearchParamSortByCond
} from "@/utils";
import PaginationBox from "@/components/common/pagination/PaginationBox.vue";
import ListHeader from "@/components/common/ListHeader.vue";

export default {
    name: 'CurriculumList',
    components: {ListHeader, ListTopBox, PaginationBox},
    data() {
        return {
            index:0,
            curriculumScore:'',
            year:[],
            curriculums: [],
            searchParams: {
                pageable: {
                    page: 0,
                    size: 20,
                    sort: [
                        {
                            sortBy:"zterm",
                            direction:"ASC"
                        },
                        {
                            sortBy:"hakje",
                            direction:"ASC"
                        }
                    ],
                },
                year: "",
            },
            response:'',
            request:{
                sortList:[],
                clickCnt:[],
            },
        }
    },
    methods: {
        async changeIndex(idx) {
            //yearbox에서 인덱스를 받아서 저장
            this.searchParams.year = this.year[idx];
            await this.pagingCurriculumList();
            await this.getScore(this.searchParams.year);
        },
        async setCurriculumParam(){
            let yearResponse = await getCurriculumYearList();
            if(yearResponse === null || yearResponse === undefined || yearResponse.length === 0)
                this.year = [new Date().getFullYear()];
            else this.year = yearResponse;
            this.searchParams.year = this.year[0];
            await this.getScore(this.searchParams.year);
        },
        async pagingCurriculumList(page){
            if(isNull(page)) page = 0;
            this.searchParams.pageable.page = page;

            let searchParams = await deepCopyObject(this.searchParams);
            searchParams.pageable.page = page;

            let response = await getCurriculumList(searchParams);
            this.response = response;
            this.curriculums = response.content;
            document.getElementById('scroll_table').scrollTo(0,0);
            return response;
        },
        async getScore(year){
            let scoreResponse = await getCurriculumScore(year);
            this.curriculumScore = scoreResponse;
        },
        async sorting(k){
            this.searchParams.pageable.sort = await setSearchParamSortByCond(this.searchParams.pageable.sort, this.request, k);
            await this.pagingCurriculumList();
        },
    },
    async mounted(){
        await this.setCurriculumParam();
        await this.pagingCurriculumList();
        this.request = createSortListAndClickCnt(['zterm', 'hakje', 'text1', 'hakju', 'time2', 'langu', 'teamt'], this.searchParams.pageable.sort);
    },
}
</script>